import { createRouter } from "@tanstack/react-router";
import "./index.css";
import { Error } from "./components/Error";
import { queryClient } from "./ajax/queryClient";
import { LoadingScreen } from "@/components/LoadingScreen/LoadingScreen";

// Import the generated route tree
import { routeTree } from "./routeTree.gen";

// Create a new router instance
export const router = createRouter({
  // defaultComponent: OfflineHandler,
  routeTree,
  defaultErrorComponent: Error,
  defaultPendingComponent: LoadingScreen,
  defaultPreload: false,
  context: {
    user: undefined,
    providerUser: undefined,
    isOnboarding: false,
  },
});

// Refresh data when changing pages. Search-only navigation (such as selecting a
// chat thread) must preserve fresh guard queries so beforeLoad can reuse them.
router.subscribe("onBeforeNavigate", ({ pathChanged }) => {
  if (pathChanged) {
    queryClient.invalidateQueries();
  }
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
